export default {"src":"/_next/static/media/pepperoni.5326e340.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};